export default {
  getStage: (state) => state.stage,
  orderedStages: (state) => state.stages
    .sort((a, b) => a.order - b.order),
};
